'use strict';

/**
 *
 * @name: tagsConfig
 *
 */

function TagsConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('TagBundle');
  }

  $stateProvider
    .state('main.tagLanding', {
      url: 'topics',
      templateProvider: $templateCache => $templateCache.get('tag-landing.index.html'),
      controller: 'TagLandingController as tagLanding',
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.tagSingle', {
      url: 'topic/:slug/:postSlug',
      params: {
        postSlug: {
          value: null,
          squash: true
        },
        slug: {
          value: null
        }
      },
      templateProvider: $templateCache => $templateCache.get('tag-single.index.html'),
      controller: 'TagSingleController as TAGC',
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    });
}

export default TagsConfig;



// WEBPACK FOOTER //
// ./app/pages/tag/tag.config.js